import { useEffect, useState } from "react";
import { Timer } from "lucide-react";
import { api, money } from "@/lib/api";

export const WaitTimer = ({ arrivedAt, fees: feesProp }) => {
  const [secs, setSecs] = useState(0);
  const [fees, setFees] = useState(feesProp);
  useEffect(() => { if (!feesProp) api.get("/pricing").then(({ data }) => setFees(data)).catch(() => {}); }, [feesProp]);
  useEffect(() => {
    const tick = () => setSecs(Math.max(0, Math.floor((Date.now() - new Date(arrivedAt).getTime()) / 1000)));
    tick();
    const t = setInterval(tick, 1000);
    return () => clearInterval(t);
  }, [arrivedAt]);
  const free = (fees?.free_wait_minutes ?? 2) * 60;
  const rate = fees?.wait_rate ?? 0.33;
  const over = secs - free;
  const mins = over > 0 ? Math.ceil(over / 60) : 0;
  const mm = String(Math.floor(secs / 60)).padStart(2, "0");
  const ss = String(secs % 60).padStart(2, "0");
  return (
    <div data-testid="wait-timer" className={`flex items-center gap-3 rounded-xl border p-4 ${mins ? "border-amber-500/40 bg-amber-500/5" : "border-white/10"}`}>
      <Timer className="h-5 w-5 text-amber-400" />
      <div className="flex-1">
        <p className="lux-eyebrow">Wait time</p>
        <p className="font-mono text-2xl text-amber-50" data-testid="wait-timer-clock">{mm}:{ss}</p>
      </div>
      <p className="text-right text-xs text-zinc-400" data-testid="wait-timer-charge">
        {mins ? <>{mins} min × {money(rate)}<br /><span className="text-amber-200">{money(mins * rate)}</span></> : `Free for ${free / 60} min`}
      </p>
    </div>
  );
};
